import { apiConfig, braavosFetch } from '../api/ApiUtils';
import { HttpMethods, ContentTypes } from '../api/types';
import { getValidClientToken } from '../auth/ClientAuth.util';

const { setConfig } = apiConfig();

export const fetchInAppMsg = async () => {
  const token = await getValidClientToken();

  const response = await braavosFetch(
    '/v1/users/current/settings?page=1&pageSize=100',
    setConfig({
      method: HttpMethods.GET,
      contentType: ContentTypes.JSON,
      token,
    }),
  );
  const results = await response.json();

  const message = results.items.find((item: any) => item.name === 'Holiday Shipping Message').value as string;

  // Should be like 07/04/2021_07/06/2021
  const dateRangeStr = results.items.find((item: any) => item.name === 'Holiday Ship Message Display Date Range').value;
  const splitDateRange = dateRangeStr.split('_');
  if (splitDateRange.length !== 2) {
    throw new Error(`Date range does not have a length of two when split at '_'`, dateRangeStr);
  }
  const dateRange: [Date, Date] = [new Date(splitDateRange[0]), new Date(splitDateRange[1])];

  const displayCounterStr = results.items.find(
    (item: any) => item.name === 'Holiday Ship Message Display Counter',
  ).value;
  const displayCounter = isNaN(displayCounterStr) ? null : parseInt(displayCounterStr);

  return {
    message,
    dateRange,
    displayCounter,
  };
};
